import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import WinTV from "@/pages/WinTV";
import EarthInnovation from "@/pages/EarthInnovation";
import AICouncil from "@/pages/AICouncil";
import WorldAI from "@/pages/WorldAI";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";
import MemberArea from "@/pages/MemberArea";
import AIAgents from "@/pages/AIAgents";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/wintv" element={<WinTV />} />
            <Route path="/earth" element={<EarthInnovation />} />
            <Route path="/ai-council" element={<AICouncil />} />
            <Route path="/world-ai" element={<WorldAI />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/members" element={<MemberArea />} />
            <Route path="/agents" element={<AIAgents />} />
          </Routes>
        </Layout>
        <Toaster position="bottom-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
